import { useEffect } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { selectIsSectionFinished } from "../store/selectors";
import { toggleSidebar } from "../store/actions";
import { trackAdobeSectionLoaded } from "../utils/adobeLogging";

export default function useProgress() {
  const history = useHistory();
  const section = useSelector((state) => state.progress.section);
  const lang = useSelector((state) => state.ui.lang);
  const currentPosition = useSelector(
    (state) => state.progress.currentPosition
  );
  const progress = useSelector((state) => state.progress);
  const dispatch = useDispatch();

  const finished = useSelector((state) =>
    selectIsSectionFinished(state, section)
  );

  useEffect(() => {
    // trackAdobeSectionLoaded({ courseName: section});
    // New user must accept terms to continue
    if (!progress.termsAccepted) {
      return history.push("/terms");
    }

    // terms are accepted but assessment is not finished yet
    if (progress.termsAccepted && !progress.assessmentDone) {
      return history.push("/app/activity/assessment");
    }

    if (finished) {
      return history.push("/app/congratulations");
    }

    // User went through all intros - redirect to last position in application
    if (progress.termsAccepted && progress.assessmentDone) {
      if (window.innerWidth < 415) {
        dispatch(toggleSidebar());
      }
      const sectionName = section === "PMAgile" ? "agile" : "waterfall";
      const path = currentPosition[lang][sectionName + "Path"];
      if (!path.includes("undefined") && path!=='/progress') {
        return history.push(currentPosition[lang][sectionName + "Path"]);
      }
    }

    return history.push("/app");
  }, []);
}
